"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { getCloudinaryUrl } from "@/lib/cloudinary";
import { MyNauiLongArrowRight } from "@/assets/icons/mynaui-long-arrow-right";

export const HeadSpaSection = () => {
  const headSpaFeatures = [
    {
      title: "Massages crâniens",
      description: "Techniques d'acupression pour libérer les tensions",
      image: getCloudinaryUrl("soiree-massage-detente-voyage-sonore"),
      link: "/head-spa",
    },
    {
      title: "Rituels énergétiques",
      description: "Gestes précis inspirés de la tradition japonaise",
      image: getCloudinaryUrl("soiree-massage-bien-etre-voyage-sonnore"),
      link: "/head-spa",
    },
    {
      title: "Expérience sensorielle",
      description: "Lumière tamisée, parfums délicats et lâcher-prise total",
      image: getCloudinaryUrl("head-spa-massage"),
      link: "/head-spa",
    },
  ];

  return (
    <section className="flex w-full flex-col gap-[3rem] px-4 py-20 ph:px-24 md:gap-0 md:px-48 lg:px-72 xl:px-96">
      <div className="flex w-full flex-col justify-between md:flex-row">
        <h2 className="mb-2 font-cormorant text-4xl text-primary ph:text-5xl sm:text-6xl md:mb-12 lg:mb-16 lg:text-7xl">
          HEAD SPA
        </h2>
        <Link
          href="/head-spa"
          className="inline-flex flex-row items-center gap-2 text-sm text-primary transition-colors hover:text-gold xs:ml-1 ph:text-base md:mb-5 md:ml-0 lg:mb-7 xl:mb-8"
        >
          En savoir plus
          <MyNauiLongArrowRight className="h-4 w-4 ph:h-6 ph:w-6" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {headSpaFeatures.map((feature, index) => (
          <Link
            href={feature.link}
            key={index}
            className="group"
            aria-label={`Découvrir ${feature.title}`}
          >
            <div className="flex flex-col gap-4">
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <div className="absolute inset-0 z-10 bg-black/20 transition-all group-hover:bg-black/30" />
                <Image
                  src={feature.image}
                  alt={`Head Spa - ${feature.title}`}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  className="object-cover transition-transform duration-500 ease-out group-hover:grayscale"
                />
                <div className="absolute bottom-0 left-0 right-0 z-20 p-6">
                  <h3 className="text-xl font-medium text-white">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-200">{feature.description}</p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-12 flex flex-col items-center gap-6 bg-gray-50 p-8 text-center">
        <h3 className="text-2xl font-medium text-gray-900">
          Le Head Spa by Alexandra Grey ouvre officiellement ses portes
        </h3>
        <p className="max-w-2xl text-gray-600">
          Votre voyage commence ici. Inspiré du Japon, notre soin transcende la
          beauté pour devenir une véritable expérience de reconnexion. Et vous,
          qu&apos;attendez-vous de votre moment de lâcher-prise ?
        </p>
        <div className="text-center">
          <Link
            href="https://www.planity.com/au-grey-des-couleurs-94800-villejuif"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-block overflow-hidden border border-primary bg-white px-8 py-3 text-base font-medium text-primary transition-colors ph:text-lg"
          >
            <span className="relative z-10 transition-colors group-hover:text-white">
              Réserver votre séance
            </span>
            <div className="absolute bottom-0 left-0 h-full w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full"></div>
          </Link>
        </div>
      </div>
    </section>
  );
};
